define('models/StoreLocatorSearchCollection',['underscore', 'ObjectCollection', 'models/StoreLocatorSearchModel'],
    function (_, ObjectCollection, StoreLocatorSearchModel) {
    //
    // Collection StoreLocatorSearch
    //

    var noResultsCollection, loadingResultsCollection;

    var StoreLocatorSearchCollectionPrototype = {

        name: 'StoreLocatorSearchCollection',
        route: 'apiStoreLocatorSearchCollection',
        model: StoreLocatorSearchModel,
        international:false,

        initialize: function () {
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(collection, arguments);
            collection.on('sync',collection.onSync,collection);
            collection.on('error',collection.onError,collection);
            //
        },
        initStoreLocator:function(storeLocator){
            StoreLocatorSearchModel.initStoreLocator(storeLocator);
        },
        url:function(){
            var collection = this, currentSearch = collection.currentSearch = collection.inputSearch;
            return ObjectCollection.prototype.url.apply(collection, [{search:currentSearch}]);
        },
        search:function(search){
            var collection = this;
            if(collection.inputSearch !== search){
                collection.inputSearch = search;
                if(!search) {
                    // empty search
                    collection.empty();
                }else if(!collection.fetching){
                    collection.fetching = true;
                    collection.fetch();
                }
            }else{
                collection.trigger('searchComplete');
            }
        },
        onSync:function(){
            var collection = this;
            collection.fetching = false;
            if(collection.currentSearch!==collection.inputSearch){
                collection.search(collection.inputSearch);
            }else{
                collection.trigger('searchComplete');
            }
        },
        onError:function(){
            this.empty();
            this.onSync();
        },
        empty:function(){
            var collection = this;
            collection.currentSearch = collection.inputSearch = '';
            collection.fetching = false;
            collection.reset();
        },
        getEmptyCollection:function() {
            return this.fetching ? this.getLoadingCollection() : this.getNoResultsCollection();
        },
        getNoResultsCollection:function(){
            if(!noResultsCollection){
                noResultsCollection = new StoreLocatorSearchCollection([{
                    object_type:'empty',
                    id_object:'empty',
                    url: '',
                    title: app.t('Aucun résultat trouvé','Stores'),
                    icon: null
                }]);
            }
            return noResultsCollection
        },
        getLoadingCollection:function(){
            if(!loadingResultsCollection){
                loadingResultsCollection = new StoreLocatorSearchCollection([{
                    object_type:'loading',
                    id_object:'loading',
                    url: '',
                    title: app.t('Chargement des résultats','Stores'),
                    icon: null
                }]);
            }
            return loadingResultsCollection
        }
    };

    var StoreLocatorSearchCollection = ObjectCollection.extend(StoreLocatorSearchCollectionPrototype);

    return StoreLocatorSearchCollection;
});

